var _style, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMenuDarkBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "menu-dark-blue_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1024 1024"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".menu-dark-blue_svg__st31{fill:none;stroke:#20274e;stroke-width:65;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M132.5 513.2h691.3M132.5 733.2h611.8M132.5 290.8h759"
  })));
}

export default SvgMenuDarkBlue;